import React from 'react';
import { UserListPage } from './list';

export const UsersModule = () => {
  return <UserListPage />;
};
